import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';

type Props = {
  label: string;
  disabled: boolean;
  checked: boolean;
  name: string;
  value: string;
  title: string;
  onChange: Function;
  isRadio: boolean;
};
const SwitchCheckbox: FC<Props> = ({ label, disabled, checked, name, value, title, onChange, isRadio }) => {
  const [check, setCheck] = useState<boolean>(false);

  useEffect(() => {
    if (disabled) {
      setCheck(false);
    }
  }, [disabled]);

  useEffect(() => {
    setCheck(checked);
  }, [checked]);

  const handleOnClick = e => {
    if (disabled) {
      return;
    }

    if (isRadio && check) {
      return;
    }
    const payload = {
      target: {
        name,
        value,
        checked: !check,
      },
    };
    onChange(payload);
    setCheck(!check);
  };
  return (
    <div>
      <WrapperWithLabel title={title} onClick={handleOnClick} name={name} value={value} checked={check}>
        <Wrapper disabled={disabled} isChecked={check}>
          <RoundButton isChecked={check} disabled={disabled} />
        </Wrapper>
        <Label title={title} disabled={disabled}>
          {label}
        </Label>
      </WrapperWithLabel>
    </div>
  );
};

export default SwitchCheckbox;

const Wrapper = styled.div<{ disabled: boolean; isChecked: boolean }>`
  position: relative;
  width: 40px;
  height: 22px;
  margin: 4px 10px 4px 0;
  border-radius: 999px;
  border: none;
  background-color: ${({ disabled, isChecked }) => {
    if (disabled) return 'var(--neutral-200)';
    return isChecked ? 'var(--primary-600)' : 'var(--neutral-300)';
  }};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: background-color 0.2s ease;
  flex-shrink: 0;

  &:hover {
    background-color: ${({ disabled, isChecked }) => {
      if (disabled) return 'var(--neutral-200)';
      return isChecked ? 'var(--primary-700)' : 'var(--neutral-400)';
    }};
  }
`;

const WrapperWithLabel = styled.div<Partial<Props>>`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, Roboto, sans-serif;
`;

const Label = styled.div<{ disabled: boolean }>`
  font-size: 0.875rem;
  font-weight: 500;
  color: ${({ disabled }) => (disabled ? 'var(--neutral-400)' : 'var(--mainText)')};
`;

const RoundButton = styled.div<{
  isChecked: boolean;
  disabled: boolean;
}>`
  position: absolute;
  top: 2px;
  left: ${({ isChecked }) => (isChecked ? '20px' : '2px')};
  height: 18px;
  width: 18px;
  border-radius: 50%;
  background-color: var(--neutral-0);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.2);
  transition: left 0.2s ease;
`;
